<nav class="header-container" [ngClass]="menuIsClosed ? 'closed-menu' : 'open-menu'">
    <div
        class="log-button-select-container"
        [ngClass]="menuIsClosed ? 'log-button-select-container-small' : 'log-button-select-container-large'">
        <img *ngIf="!menuIsClosed" class="logo" (click)="redirectToHome()" src="assets/images/adspace-logo.png" alt="Adspace" />
        <button
            type="button"
            class="tv-round-icon-button-icon-medium-light-blue"
            (click)="onCloseMenuButtonClick()"
            aria-label="Toggle menu">
            <img
                [src]="
                    menuIsClosed
                        ? 'assets/images/icons/tv-icons/open-menu-icon.svg'
                        : 'assets/images/icons/tv-icons/close-menu-icon.svg'
                "
                alt="" />
        </button>
    </div>

    <div *ngIf="isDev && !menuIsClosed" class="select-container">
        <div class="tv-container-select-white-round-extensible-low-height width-180px">
            <mat-form-field>
                <mat-select panelClass="tv-custom-always-visible-scroll-bar" [formControl]="currentMenuOption">
                    <mat-option class="tv-ns-select-option" *ngFor="let devMenuOption of devMenuOptions" [value]="devMenuOption">{{
                        devMenuOption.label
                    }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <ul class="menu-list-container" *ngIf="!!identity">
        <div *ngFor="let menuItem of menuItems" class="menu-item">
            <div class="menu-item-wrapper">
                <div
                    class="label-and-icon-container"
                    [ngClass]="menuIsClosed ? 'label-and-icon-container-small' : 'label-and-icon-container-large'"
                    [routerLink]="[menuItem.link]"
                    routerLinkActive="menu-item-active">
                    <img
                        class="menu-icon"
                        *ngIf="menuItem.icon"
                        src="{{ menuItem.icon }}"
                        [ngClass]="{ 'margin-right-10': !menuIsClosed }"
                        alt="menu-icon" />
                    <p *ngIf="!menuIsClosed" class="menu-label">{{ menuItem.label }}</p>
                </div>
                <div *ngIf="menuItem.isLastInSection" class="menu-section-separator"></div>
            </div>
        </div>
    </ul>
    <div class="user-container" *ngIf="!!identity" [ngClass]="menuIsClosed ? 'user-container-small' : 'user-container-large'">
        <mat-icon *ngIf="!menuIsClosed" class="user-icon">person</mat-icon>
        <p>{{ name }}</p>
        <mat-icon *ngIf="!menuIsClosed" class="logout-icon" (click)="onClickLogout()">logout</mat-icon>
    </div>
</nav>
